function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import React from "react";
import classesPropType from "@xo-union/classes-prop-type";
import { useButtonClasses } from "./ThemeContext.js";
var ANIMATION_DURATION = 250;
export var useAnimationProps = function useAnimationProps() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    clicked = _React$useState2[0],
    setClicked = _React$useState2[1];
  var timerRef = React.useRef();
  var onClick = React.useCallback(function () {
    setClicked(true);
    clearTimeout(timerRef.current);
    timerRef.current = _setTimeout(function () {
      setClicked(false);
    }, ANIMATION_DURATION);
  }, []);
  React.useEffect(function () {
    return function () {
      clearTimeout(timerRef.current);
    };
  }, []);
  return {
    clicked: clicked,
    onClick: onClick
  };
};
export var AnimatedElement = function AnimatedElement(_ref) {
  var classesProp = _ref.classes;
  var classes = useButtonClasses(classesProp);
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classes['animated-element']
  });
};
process.env.NODE_ENV !== "production" ? AnimatedElement.propTypes = {
  /**
   * Class dependencies
   */
  classes: classesPropType(['animated-element'])
} : void 0;